<template>
  <router-view></router-view>
</template>
<script>
import {SECTION_NAMES} from "@/module_dashboard/store/layout";
import {createNamespacedHelpers} from "vuex";

const {
  mapState: layoutState,
  mapMutations: layoutMutations,
  mapActions: layoutActions,
} = createNamespacedHelpers("dashboard/layout");

export default {
  name: "User",
  data() {
    return {
      navList: [
        {
          name: 'USERS',
          toPageName: 'UsersManagement'
        },
        {
          name: 'TEAMS',
          toPageName: 'TeamsManagement'
        },
        {
          name: 'USER INFO',
          toPageName: 'UserProfileInfo',
          hidden: true,
        }
      ]
    }
  },
  methods: {
    ...layoutMutations(['setHeaderNavItems', 'setLastActivePageName']),
    ...layoutActions(['getLastActivePageName'])
  },
  async mounted() {
    this.setHeaderNavItems(this.navList);
    const lastActivePageName = await this.getLastActivePageName(SECTION_NAMES.UserManagement);
    const activePageName = this.$route.name;

    const childPages = this.navList.map(nav => nav.toPageName);
    if (childPages.includes(activePageName)) {
      this.setLastActivePageName({
        index: SECTION_NAMES.UserManagement,
        pageName: activePageName
      });
    } else {
      this.$router.push({name: lastActivePageName});
    }
  },
  beforeDestroy() {
    this.setHeaderNavItems([]);
  }
}
</script>